import GoogleMapsLink from './GoogleMapsLink';

export default GoogleMapsLink;